import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import SurplusResources37_2Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const SurplusResources37_2 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_MATERIALS_INSTALLATION") || "Surplus materials generated in Installation and Construction"}
        subDescription={t("SURPLUS_MATERIALS_37_2_DESC") || "List here the materials consumed during installation and construction that do not form part of the final product but are required for its manufacturing, and became surplus materials. Choose how they are treated."}
        isNormal={true}
        number={"37.2"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`surplus-resources-37-2-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <SurplusResources37_2Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default SurplusResources37_2;

